import type { CuratedCopy } from "./preview-copy.types";
export const sugarscapeCopy: CuratedCopy = {
  blurb:
    "Gnomish citizens roam a grid of sugar, harvesting, trading and sometimes fighting, all from a few simple rules. You write the rules, then watch the society that grows from them.",
  beats: () => [
    {
      title: "Write a ruleset",
      body: "Submit one SugarLang ruleset aimed at the general welfare, or a generator that builds a ruleset for any target you are given.",
    },
    {
      title: "Run the simulation",
      body: "Your rules run on a random world. Gnomes harvest, eat, trade, mate and fight, and their hats grow with their wealth.",
    },
    {
      title: "Score the society",
      body: "A ruleset is scored on the overall happiness of its society; a generator is scored on how close it gets to the target distribution, such as an egalitarian Gini.",
    },
  ],
};
